module.exports = __webpack_public_path__ + "measuring-tape-yellow.ea3f9927f7d91066755c06d0b6f9809e.svg";